import { useIsMobile } from '@hooks/use-mobile.tsx';

export const useIsAuthenticatedFwmiMobile = (isAuthenticated: boolean) => {
  const isMobile = useIsMobile();
  const isMobileViewport =
    isMobile || (typeof window !== 'undefined' && window.innerWidth < 768);

  return (
    isAuthenticated && isMobileViewport && window.__config__.name === 'fwmi'
  );
};
